import React, {Component} from "react";
import { inject } from "mobx-react/index";
import { Col, Label, FormGroup } from "reactstrap";
import moment from 'moment';
import 'rmc-picker/assets/index.css';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

@inject("store")
export default class FormDatePicker extends Component {

    constructor(props){
        super(props)

        this.state = {
            date: this.props.date ? this.props.date : null,
            focused: false
        }

        this.onChangeDate = this.onChangeDate.bind(this)
    }

    onChangeDate(event){
        this.setState({
            date: event
        })

        event ? this.props.onChange(event.format()) : this.props.onChange(event) 
    }

    componentDidMount(){
        this.state.date
        && this.props.onChange(this.state.date.format())
    }

    render() {
        return (
            <Col 
                xs={this.props.xs || 'auto'}
                sm={this.props.sm || 'auto'}
                md={this.props.md || 'auto'}
                lg={this.props.lg || 'auto'}
                xl={this.props.xl || 'auto'}
            >
                <FormGroup>
                    { this.props.titulo && <Label>{ this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } </Label> }
                    <div>
                        <SingleDatePicker
                            placeholder = "Data"
                            disabled={!!this.props.bloqueado}
                            date={this.state.date}
                            onDateChange={this.onChangeDate}
                            focused={this.state.focused}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            id={this.props.uniqueId}
                            hideKeyboardShortcutsPanel={true}
                            numberOfMonths = {1}
                            isOutsideRange={() => false}
                            openDirection={this.props.openUp ? 'up' : 'down'}
                            showClearDate={this.props.showClearDate}
                        />
                    </div>
                    { this.props.alerta
                        && <Label className="label-danger">{ this.props.alerta }</Label>
                    }
                </FormGroup>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormDatePicker.js